import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition
} from '@evinced-private/ui-common';

import { DATE_RANGE_FILTER_LABEL } from 'src/common/consts/FilterPanelConsts';
import { DEFAULT_PERIOD_OPTION } from 'src/common/helpers/DataFilterHelper';
import { IPinnableSelectFilterDefinition } from 'src/common/helpers/FiltersPanelHelper';

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {}
};

const sdkTypeFilter: ISelectFilterDefinition = {
	id: 'sdkType',
	label: 'SDK Type',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'SDK Type',
		allSelectedPlaceholder: 'All SDK Types',
		someItemsSelectedText: (numberOfItems: number) => `SDK Types (${numberOfItems})`,
		isMultiple: true,
		className: 'labels-filter-dropdown',
		id: 'sdkType',
		label: 'SDK Type',
		listboxWidth: '140px'
	}
};

// temporary hid this filter. Will be addressed in Mobile Platform phase 2
// const sdkVersionFilter: ISelectFilterDefinition = {
// 	id: 'sdkVersion',
// 	label: 'SDK Version',
// 	filterType: 'select',
// 	defaultValue: [],
// 	componentProps: {
// 		placeholder: 'SDK Version',
// 		allSelectedPlaceholder: 'All SDK Versions',
// 		someItemsSelectedText: (numberOfItems: number) => `SDK Versions (${numberOfItems})`,
// 		isMultiple: true,
// 		className: 'labels-filter-dropdown',
// 		id: 'sdkVersion',
// 		label: 'SDK Version',
// 		listboxWidth: '140px'
// 	}
// };

const platformFilter: ISelectFilterDefinition = {
	id: 'platform',
	label: 'Platform',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Platform',
		allSelectedPlaceholder: 'All platforms',
		someItemsSelectedText: (numberOfItems: number) => `Platforms (${numberOfItems})`,
		isMultiple: true,
		className: 'labels-filter-dropdown',
		id: 'platform',
		label: 'Platform',
		listboxWidth: '140px'
	}
};

const appNameFilter: ISelectFilterDefinition = {
	id: 'appName',
	label: 'App Name',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'App Name',
		allSelectedPlaceholder: 'All App Names',
		someItemsSelectedText: (numberOfItems: number) => `App Names (${numberOfItems})`,
		isMultiple: true,
		className: 'labels-filter-dropdown',
		id: 'appName',
		label: 'App Name',
		listboxWidth: '140px'
	}
};

// TODO: Uncomment after backend support for filtering is ready
// const appVersionFilter: ISelectFilterDefinition = {
// 	id: 'appVersion',
// 	label: 'App Version',
// 	filterType: 'select',
// 	defaultValue: [],
// 	componentProps: {
// 		placeholder: 'App Version',
// 		allSelectedPlaceholder: 'All App Versions',
// 		someItemsSelectedText: (numberOfItems: number) => `App Versions (${numberOfItems})`,
// 		isMultiple: true,
// 		className: 'labels-filter-dropdown',
// 		id: 'appVersion',
// 		label: 'App Version',
// 		listboxWidth: '140px'
// 	}
// };

const severityFilter: ISelectFilterDefinition = {
	id: 'severity',
	label: 'Severity',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Severity',
		allSelectedPlaceholder: 'All severities',
		someItemsSelectedText: (numberOfItems: number) => `Severities (${numberOfItems})`,
		isMultiple: true,
		id: 'severity',
		label: 'Severity',
		listboxWidth: '140px'
	}
};

const sessionsPeriodFilter: IPinnableSelectFilterDefinition = {
	id: 'sessionsPeriod',
	label: DATE_RANGE_FILTER_LABEL,
	filterType: 'select',
	defaultValue: [DEFAULT_PERIOD_OPTION],
	isPinned: true,
	componentProps: {
		placeholder: 'Select Tests Period',
		isMultiple: false,
		id: 'sessionsPeriod',
		label: DATE_RANGE_FILTER_LABEL,
		listboxWidth: '140px'
	}
};

export const MobileSdkTestsPageFilterDefinitions: IFilterDefinition[] = [
	searchFilter,
	sdkTypeFilter,
	// temporary hid this filter. Will be addressed in Mobile Platform phase 2
	// sdkVersionFilter,
	platformFilter,
	appNameFilter,
	// appVersionFilter,
	severityFilter,
	sessionsPeriodFilter
];
